import GetNewsResponse from '../CRM/Responses/NewsResponse';

import Model from './Model';

import { LanguageResponse } from 'Api/CRM/Responses/LanguagesResponse';
import GetNewsCategoryResponse from 'Api/CRM/Responses/NewsCategoryResponse';
import GetSeoTagResponse from 'Api/CRM/Responses/SeoTagResponse';

export default class News extends Model {
    readonly id: number;
    readonly language_id: number;
    readonly translation_id: number;
    readonly news_category_id: number;
    readonly title: string;
    readonly slug: string;
    readonly short_text: string;
    readonly text: string;
    readonly publication_date: string;
    readonly image: string | null;
    readonly image_alt: string | null;
    readonly is_draft: boolean = false;
    readonly is_trashed: boolean = false;
    // additional props
    readonly language: LanguageResponse;
    readonly news_category: GetNewsCategoryResponse;
    readonly seo_tag: Partial<GetSeoTagResponse> | null;

    constructor(news: Partial<GetNewsResponse>) {
        super();
        this.assignDataToProps(news, [
            'id',
            'language_id',
            'translation_id',
            'news_category_id',
            'title',
            'slug',
            'short_text',
            'text',
            'publication_date',
            'language',
            'news_category',
            'image',
            'image_alt',
            'is_draft',
            'is_trashed',
            'seo_tag',
        ]);
    }
}
